import createIcon from "../createIcon";
import React from "react";

export const ArrowDownIcon = createIcon({
  path: (
    <path
      d="M31.7609 18.5791L24.0009 26.3391L16.2409 18.5791C15.4609 17.7991 14.2009 17.7991 13.4209 18.5791C12.6409 19.3591 12.6409 20.6191 13.4209 21.3991L22.6009 30.5791C23.3809 31.3591 24.6409 31.3591 25.4209 30.5791L34.6009 21.3991C35.3809 20.6191 35.3809 19.3591 34.6009 18.5791C33.8209 17.8191 32.5409 17.7991 31.7609 18.5791Z"
      fill="currentColor"
    />
  )
});

export default ArrowDownIcon;
